import { DialogActions, Button, Spinner } from '@fluentui/react-components';
import { SetStateAction } from 'react';

interface SignUpActionProps {
	isLoading: boolean;
	toggleModal: React.Dispatch<SetStateAction<boolean>>;
	submitForm: () => Promise<unknown>;
}

export default function SignUpActions(props: SignUpActionProps) {
	return (
		<DialogActions>
			<Button
				type='button'
				appearance='secondary'
				onClick={() => {
					props.toggleModal(false);
				}}
			>
				Cancel
			</Button>

			<Button
				type='button'
				appearance='primary'
				onClick={() => props.submitForm()}
				disabled={props.isLoading}
			>
				{!props.isLoading && <>Embark</>}
				{props.isLoading && <Spinner size='extra-small' />}
			</Button>
		</DialogActions>
	);
}
